import { serializable, alias, primitive, list, object } from 'serializr';

// Not role.model.ts's Role: that class aliases its field from "role", not "name".
export class UserAccessRole {
  @serializable(alias('id', primitive()))
  id!: number;

  @serializable(alias('name', primitive()))
  name!: string;
}

export class UserRecord {
  @serializable(alias('id', primitive()))
  id!: number;

  @serializable(alias('name', primitive()))
  name!: string;

  @serializable(alias('title', primitive()))
  title!: string;

  // Absent on the list endpoint; present on GET /org/users/:id.
  @serializable(alias('email', primitive()))
  email?: string;

  @serializable(object(UserAccessRole))
  role!: UserAccessRole;

  @serializable(alias('accessExpiresAt', primitive()))
  accessExpiresAt!: string | null;

  @serializable(list(primitive()))
  groups!: string[];

  // Backend doesn't send this; set after deserialize() from accessExpiresAt.
  durationStatus?: 'normal' | 'critical';
}

export class PaginationMeta {
  @serializable(alias('total', primitive()))
  total!: number;

  @serializable(alias('limit', primitive()))
  limit!: number;

  @serializable(alias('offset', primitive()))
  offset!: number;

  @serializable(alias('hasMore', primitive()))
  hasMore!: boolean;
}

export class UsersListResponse {
  @serializable(list(object(UserRecord)))
  users!: UserRecord[];

  @serializable(object(PaginationMeta))
  pagination!: PaginationMeta;
}
